var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.928,
    height: 28.927,
    viewBox: "0 0 28.928 28.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-square",
    "data-name": "Icon awesome-facebook-square",
    d: "M25.828,2.25H3.1A3.1,3.1,0,0,0,0,5.349V28.078a3.1,3.1,0,0,0,3.1,3.1h8.862V21.343H7.894V16.714h4.068V13.186c0-4.013,2.389-6.23,6.048-6.23a24.645,24.645,0,0,1,3.585.313v3.939H19.576a2.315,2.315,0,0,0-2.61,2.5v3.006h4.441l-.71,4.629H16.966v9.835h8.862a3.1,3.1,0,0,0,3.1-3.1V5.349a3.1,3.1,0,0,0-3.1-3.1Z",
    transform: "translate(0 -2.25)",
    fill: "#2eafbe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.7e2058579015c84a801deecb81670e8e.svg";
export { ForwardRef as ReactComponent };